import Vue from 'vue'
import VueRouter from 'vue-router'
const HomeView = () =>
    import ('../views/home/HomeView');
const BidMainView = () =>
    import ('../views/bidmain/BidMainView');
const AboutUsView = () =>
    import ('../views/bidmain/children/AboutUsView');
const NewsView = () =>
    import ('../views/bidmain/children/NewsView');
const BidSelectionView = () =>
    import ('../views/bidmain/children/BidSelectionView'); //中标公告
const BidNoticeView = () =>
    import ('../views/bidmain/children/BidNoticeView'); //招标（采购）公告
const LoginView = () =>
    import ('../views/login/LoginView');
const FindPsView = () =>
    import ('../views/login/FindPsView');
const RegisterView = () =>
    import ('../views/login/RegisterView');
const NewsDetailView = () =>
    import ('../views/bidmain/children/NewsDetailView');
const NoticeDetailView = () =>
    import ('../views/bidmain/children/NoticeDetailView');
const BidSelectionDetail = () =>
    import ('../views/bidmain/children/BidSelectionDetail');
const ReNamed = () =>
    import ('../views/login/ReNamed.vue')
const BidOtherNoticeView = () =>
    import ('../views/bidmain/children/BidOtherNoticeView'); //其他公告
const ChangeDetails = () =>
    import ('../components/biddingComp/ChangeDetails'); //其他公告

Vue.use(VueRouter)
const routes = [{
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/bid',
        name: 'bid',
        component: BidMainView,
        children: [{
                path: 'news',
                name: 'news',
                component: NewsView,
            },
            {
                path: 'newsdetail',
                name: 'newsdetail',
                component: NewsDetailView,
            },
            {
                path: 'aboutus',
                name: 'aboutus',
                component: AboutUsView,
            },
            {
                path: 'bidnotice',
                name: 'bidnotice',
                component: BidNoticeView,
            },
            {
                path: 'bidselection',
                name: 'bidselection',
                component: BidSelectionView,
            },
            {
                path: 'noticedetail',
                name: 'noticedetail',
                component: NoticeDetailView,
            },
            {
                path: 'selectdetail',
                name: 'selectdetail',
                component: BidSelectionDetail
            },
            {
                path: 'otherselection',
                name: 'otherselection',
                component: BidOtherNoticeView
            }, // 其他公告 
            {
                path: 'ChangeDetails',
                name: 'ChangeDetails',
                component: ChangeDetails
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView
    },
    {
        path: '/findps',
        name: 'findps',
        component: FindPsView
    },
    {
        path: '/register',
        name: 'register',
        component: RegisterView
    },
    {
        path: '/repassword',
        name: '/repassword',
        component: ReNamed
    }
]
let scrollBehavior = function(to, from, savedPosition) {
    return { x: 0, y: 0 }
}
const router = new VueRouter({
    mode: 'history',
    // 未生效
    scrollBehavior,
    routes
})

export default router